import React from "react"
import { MenuDivider, MenuItem } from "components/dialogs/Menu"
import LinkSelector from "components/elements/LinkSelector"
import { EVENT_WEBSITE_HELP_LINK } from "utilities/externalLinks"
import { ModalName, Website } from "sharedTypes"
import useModal from "services/useModal"
import useFeatureFlag from "services/featureFlags"

type Props = {
  website: Website
  redirectPath?: string
}

const PageLinkSelector = ({ website: { published, url, previewUrl }, redirectPath }: Props) => {
  const showModal = useModal()
  const { vanityUrls: vanityUrlsEnabled } = useFeatureFlag()
  const openEventLinkSettings = () => (vanityUrlsEnabled
    ? showModal(ModalName.EventLink)
    : showModal(ModalName.WebPageURL, { redirectPath }))

  const link = published
    ? { label: "Page Link", url }
    : { label: "Preview Link", url: previewUrl }

  const actions = [
    <MenuItem key="event-link" onClick={openEventLinkSettings}>
      {vanityUrlsEnabled ? "Event Link Settings" : "Page URL"}
    </MenuItem>,
    <MenuItem key="google-analytics" onClick={() => showModal(ModalName.GoogleAnalytics)}>
      Google Analytics
    </MenuItem>,
    <MenuDivider key="about-divider" m={0} />,
    <MenuItem key="about" as="a" href={EVENT_WEBSITE_HELP_LINK} target="_blank" rel="noopener noreferrer">
      About Diobox Pages & Links
    </MenuItem>,
  ]

  return link.url
    ? <LinkSelector label={link.label} url={link.url} actions={actions} />
    : null
}

export default PageLinkSelector
